import Card from "./Card";
import Skeleton from "Components/Common/Skeleton/Skeleton";
import { DrawDetail, DrawTimelineEvent } from "../DrawHistory.types";
import { formatDate } from "utils/Common/Date";
import EmptyState from "Components/Common/EmptyState";
import NoDocuments from "Assets/Img/NoDocuments";

interface TimelineTabProps {
  drawDetail: DrawDetail | null;
  events: DrawTimelineEvent[];
  loading: boolean;
}

const dotVariant = (activityType: string): "done" | "active" | "blue" => {
  if (activityType.includes("INSPECTION")) return "blue";
  if (activityType.includes("REJECT")) return "active";
  return "done";
};

const TimelineTab = ({ drawDetail, events, loading }: TimelineTabProps) => {
  if (loading || !drawDetail) {
    return (
      <>
        <div className="sectionTitle">Draw Timeline</div>
        <Skeleton
          width="65%"
          height={20}
          borderRadius={4}
          style={{ marginBottom: 14 }}
        />
        <Card title="Event History">
          <div className="timeline">
            {Array.from({ length: 4 }).map((_, i) => (
              <div className="tlEvent" key={i}>
                <div className="tlDot" />
                <div className="tlContent">
                  <Skeleton
                    width="45%"
                    height={13}
                    borderRadius={4}
                    style={{ marginBottom: 5 }}
                  />
                  <Skeleton width="65%" height={11} borderRadius={4} />
                </div>
              </div>
            ))}
          </div>
        </Card>
      </>
    );
  }

  return (
    <>
      <div className="sectionTitle">Draw Timeline</div>
      <div className="sectionSub">
        Audit trail of recorded events for Draw #
        {String(drawDetail.draw.drawNumber).padStart(2, "0")}.
      </div>

      <Card title="Event History">
        {events.length === 0 ? (
          <EmptyState
            noBorder
            icon={<NoDocuments />}
            title="No timeline events recorded for this draw."
          />
        ) : (
          <div className="timeline">
            {[...events]
              .sort(
                (a, b) =>
                  new Date(a.createdAt).getTime() -
                  new Date(b.createdAt).getTime(),
              )
              .map((event) => {
                const metaParts = [
                  formatDate(event.createdAt, false),
                  event.actor?.name,
                ];
                if (
                  event.description &&
                  event.description !== event.actor?.name
                ) {
                  metaParts.push(event.description);
                }
                return (
                  <div className="tlEvent" key={event.id}>
                    <div
                      className={`tlDot ${dotVariant(event.activityType)}`}
                    />
                    <div className="tlContent">
                      <div className="tlTitle">{event.title}</div>
                      <div className="tlMeta">
                        {metaParts.filter(Boolean).join(" · ")}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </Card>
    </>
  );
};

export default TimelineTab;
